import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, PropsWithChildren } from 'react';

/**
 * Presentational layout primitives for the draft-send panels. Purely
 * carry the shared classes — consumers own what goes where.
 */

type PanelSlotProps = PropsWithChildren<{ className?: string }>;

const PanelHeaderBarRoot: FC<PanelSlotProps> = (props) => {
  const { children, className } = props;
  return (
    <div
      className={clstx(
        'flex items-center justify-between gap-x-8 gap-y-2 border-b border-gray-200 p-3.5 flex-wrap',
        className
      )}
    >
      {children}
    </div>
  );
};

const PanelHeaderBarGroup: FC<PanelSlotProps> = (props) => {
  const { children, className } = props;
  return (
    <div className={clstx('flex items-center gap-x-2', className)}>
      {children}
    </div>
  );
};

const PanelHeaderBarActions: FC<PanelSlotProps> = (props) => {
  const { children, className } = props;
  return (
    <div className={clstx('flex items-center gap-x-2 ml-auto', className)}>
      {children}
    </div>
  );
};

export const PanelHeaderBar = Object.assign(PanelHeaderBarRoot, {
  Group: PanelHeaderBarGroup,
  Actions: PanelHeaderBarActions,
});

const PanelBodyRoot: FC<PanelSlotProps> = (props) => {
  const { children, className } = props;
  return (
    <div
      className={clstx(
        'relative flex-1 min-h-0 flex flex-col overflow-y-auto',
        className
      )}
    >
      {children}
    </div>
  );
};

const PanelBodyContent: FC<PanelSlotProps> = (props) => {
  const { children, className } = props;
  return <div className={clstx('p-4', className)}>{children}</div>;
};

export const PanelBody = Object.assign(PanelBodyRoot, {
  Content: PanelBodyContent,
});
